import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NzTypographyModule } from 'ng-zorro-antd/typography';

import { ThemeService } from '@services/theme.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-not-found',
  imports: [NzTypographyModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './not-found.component.html',
})
export class NotFoundComponent implements OnInit {
  constructor(
    private themeService: ThemeService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.themeService.setNavTitle(this.translate.instant('pages.not-found.nav-title'));
  }
}
